import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import {
  HORIZ_DRAG_HANDLER_ICON_HEIGHT,
  HORIZ_DRAG_HANDLER_ICON_WIDTH,
  VERT_DRAG_HANDLER_ICON_HEIGHT,
} from '@databases/icons';
import Z_INDEX from '@databases/layout/z-index';
import { TABLE_CLASSNAMES } from '@databases/utils/constants';
import styled, { css } from 'styled-components';

export const selectButtonActiveStyle = css`
  background-color: ${token('color.background.accent.blue.subtler.pressed', colors.B200)};
  color: ${token('color.text.inverse', colors.N0)};
`;

export const selectButtonDeletionActiveStyle = css`
  background-color: ${token('color.background.accent.red.subtler.pressed', colors.R400)};
  color: ${token('color.text.inverse', colors.N0)};
`;

/* The row select button container has:
 * - a position: sticky to keep the select button in place when scrolling
 * - a z-index to make sure the select button is on top of the table
 * - a left: 0 to make sure the select button is aligned with the left border of the table
 *
 * The button has:
 * - a position: absolute to take the button out of the flow
 * - an offset from top is 50% of the cell height, minus half the table border width.
 *   we then subtract half of the table border width, which is 1px
 *
 * We do something similar for the column select button.
 */
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export const RowSelectButtonContainer = styled.td`
  position: sticky !important;
  z-index: ${Z_INDEX.ROW_SELECT_BUTTON};
  left: 0;

  .${TABLE_CLASSNAMES.SELECT_BUTTON} {
    position: absolute;
    top: calc(50% - ${VERT_DRAG_HANDLER_ICON_HEIGHT / 2 - 1 / 2}px);
    left: -${1 / 2}px;
    width: max-content;
  }
`;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
export const ColSelectButtonContainer = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.COLUMN_SELECT_BUTTON};
  top: -${HORIZ_DRAG_HANDLER_ICON_HEIGHT / 2 - 1 / 2}px;
  left: calc(50% - ${HORIZ_DRAG_HANDLER_ICON_WIDTH / 2 - 1 / 2}px);
`;

export const DragHandlerWrapper = styled.div<{
  isActive: boolean;
  isDeletionActive: boolean;
}>`
  ${({ isActive, isDeletionActive }) =>
    isActive &&
    css`
      &&& {
        ${isDeletionActive ? selectButtonDeletionActiveStyle : selectButtonActiveStyle};
        display: flex;
      }
    `}
`;
